import { render, staticRenderFns } from "./AppDialogOneway.vue?vue&type=template&id=9b56c522&scoped=true&"
import script from "./AppDialogOneway.vue?vue&type=script&lang=ts&"
export * from "./AppDialogOneway.vue?vue&type=script&lang=ts&"
import style0 from "./AppDialogOneway.vue?vue&type=style&index=0&id=9b56c522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56c522",
  null
  
)

export default component.exports